import React from "react";
import Administacion from "./Administacion/Administacion";
import Operaciones from "./Operaciones/Operaciones";
import TalentoHumano from "./TalentoHumano/TalentoHumano";
import SumaTravel from "./SumaTravel/SumaTravel";
import Direccion from "./Direccion/Direccion";
import Instalaciones from "./Instalaciones/Instalaciones";
import BitacorasByUnit from "./Bitacoras/Bitacoras";
import CrecimientoHumano from "./CrecimientoHumano/CrecimientoHumano";
import InnovacionDesarrollo from "./I+D/I+D";
import Mantenimiento from "./Mantenimiento/Mantenimiento";
import Admin from "./Admin/Admin";

import DashboardRoute from "./Dashboard/DashboardRoute";
import Administrador from "./Administrador/Administrador";
import Comercial from "./Comercial/Comercial";
import ExperienciaAlCliente from "./ExperienciaAlCliente/ExperienciaAlCliente";
import Cotizaciones from "./Cotizaciones/Cotizaciones";
import Seguridad from "./Seguridad/Seguridad";
import { Route } from "react-router-dom";
import Documentacion from "./Documentacion/Documentacion";


const AuthRoutes = () => {
    return (
        <>
            <DashboardRoute />
            <BitacorasByUnit />
            <Administacion />
            <Operaciones />
            <TalentoHumano />
            <SumaTravel />
            <Direccion />
            <Instalaciones />
            <CrecimientoHumano />
            <InnovacionDesarrollo />
            <Mantenimiento />
            <Admin />
            <Administrador />
            <Comercial />
            <ExperienciaAlCliente />
            <Cotizaciones />
            <Seguridad />
            <Documentacion />
            

        </>
    )
}
export default AuthRoutes